/* eslint import/no-extraneous-dependencies: 0 */

import 'bootstrap';

import { setTimeout } from 'utils/wrappers';

export function displayErrorOnField(formField, message) {
  formField.addClass('error');
  formField.popover({
    html: true,
    template: '<div class="popover popover-error"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"><p></p></div></div></div>',
    content: message,
    placement: 'bottom',
    trigger: 'manual',
    delay: 0,
  }).popover('show');
}

export function displayErrorsOnView(view, errorList, attributes) {
  let delay = 0;
  const increment = 300;
  let focusSet = false;

  attributes.forEach((attribute) => {
    const error = errorList.find(errorItem => errorItem.field === attribute);

    if (error) {
      if (!focusSet) {
        view.setFocus(attribute);
        focusSet = true;
      }

      setTimeout(() => {
        view.displayError(attribute, error.message);
      }, delay);
      delay += increment;
    }
  });
}

export function clearPopoversOnView(view) {
  view.$('input').popover('hide');
}



// WEBPACK FOOTER //
// ./utils/forms.js